<!-- src/components/CollapsiblePanel.vue -->
<template>
  <div class="collapsible-panel">
    <div class="header" @click="isOpen = !isOpen">
      <span>{{ title }}</span>
      <img
        :src="
          staticArrow
            ? arrowImages[0]
            : isOpen
            ? arrowImages[1]
            : arrowImages[0]
        "
        alt="toggle"
      />
    </div>
    <div class="content" v-show="isOpen">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    arrowImages: Array, // 必须传入一个包含两个图片路径的数组
    staticArrow: Boolean, // 新增：是否使用静态箭头
  },
  data() {
    return {
      isOpen: false,
    };
  },
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding-bottom: 20px;
  border-bottom: 1px solid #eef1f5;
  margin-top: 20px;
}
.content {
  overflow: hidden;
}
.content ul {
  list-style-type: none;
  width: 100%;
}
.content li {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3d3d3d;
  line-height: 20px;
  text-align: left;
  border-bottom: 1px solid #efeded;
  padding-bottom: 17px;
  margin-top: 20px;
}
span {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #121121;
  text-align: left;
}
img {
  width: 16px;
  height: 16px;
}
</style>
